require('./dist/ng-file-upload-all');
module.exports = 'ngFileUpload';


// WEBPACK FOOTER //
// ./~/ng-file-upload/index.js